import React from "react";
import { commonService } from "../../../utils/commonService";
import { Modal, Row, Col, Table } from "react-bootstrap";
import moment from "moment";

const ProposedRateModal = ({ showPaceModal, setShowPaceModal, data }) => {
    const currentBar = data?.[0]?.bar ? parseFloat(data?.[0]?.bar) : 0;
    const recommendedRate = data?.[0]?.recommended_rate
        ? parseFloat(data?.[0]?.recommended_rate)
        : 0;
    const compSetAvg = data?.[0]?.compset_avg
        ? parseFloat(data?.[0]?.compset_avg)
        : 0;

    const vsBar = compSetAvg - currentBar;
    const vsBarColor =
        currentBar > compSetAvg
            ? "green"
            : currentBar < compSetAvg
                ? "red"
                : "#000000";

    const getPaceBadge = (val, defaultVal, isAmount = false) => {
        let rawVal = val !== undefined && val !== null ? val : defaultVal;

        let isPositive = false;
        let numericVal = 0;

        if (typeof rawVal === "string") {
            numericVal = parseFloat(rawVal.replace(/[^\d.-]/g, ""));
            isPositive =
                rawVal.startsWith("+") || (!rawVal.startsWith("-") && numericVal >= 0);
        } else {
            numericVal = rawVal;
            isPositive = numericVal >= 0;
        }

        let formattedVal = isAmount
            ? commonService.formateAmount(Math.abs(numericVal))
            : commonService.formateRoom(Math.abs(numericVal));

        let displayVal = isPositive ? `+${formattedVal}` : `-${formattedVal}`;

        const bgColor = isPositive ? "#ecfdf5" : "#fef2f2";
        const color = isPositive ? "#059669" : "#dc2626";

        return (
            <span className="proposed-rate-pace-badge" style={{ color: color }}>
                {displayVal}
            </span>
        );
    };

    return (
        <Modal
            show={showPaceModal}
            onHide={() => setShowPaceModal(false)}
            centered
            dialogClassName="pace-modal-dialog"
            size="md"
        >
            <Modal.Header closeButton className="proposed-rate-modal-header">
                <Modal.Title className="proposed-rate-modal-title">
                    OTB — {commonService.getDateInFormat(data?.[0]?.staydate)}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="proposed-rate-modal-body">
                <div className="proposed-rate-summary-wrap">
                    <Row>
                        <Col xs={4} className="proposed-rate-col-pl">
                            <div className="proposed-rate-card">
                                <div className="proposed-rate-card-label">Recommended Rate</div>
                                <div className="proposed-rate-card-value-wrap">
                                    <span className="proposed-rate-card-value-dark">
                                        {commonService.formateAmount(recommendedRate)}
                                    </span>
                                </div>
                            </div>
                        </Col>
                        <Col xs={4} className="proposed-rate-col-pr">
                            <div className="proposed-rate-card">
                                <div className="proposed-rate-card-label">BAR RATE</div>
                                <div className="proposed-rate-card-value-blue">
                                    {commonService.formateAmount(currentBar)}
                                </div>
                            </div>
                        </Col>
                        <Col xs={4} className="proposed-rate-col-pl">
                            <div className="proposed-rate-card">
                                <div className="proposed-rate-card-label">CompSet Avg Rate</div>
                                <div className="proposed-rate-card-value-wrap">
                                    <span className="proposed-rate-card-value-dark">
                                        {commonService.formateAmount(compSetAvg)}
                                    </span>
                                    <span
                                        className="proposed-rate-vs-bar"
                                        style={{ color: vsBarColor }}
                                    >
                                        {vsBar < 0 ? "-" : "+"}
                                        {commonService.formateAmount(Math.abs(vsBar))} vs BAR
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="proposed-rate-lable">
                    <h6 className="proposed-rate-trend-label">PACE TREND</h6>

                    <div className="ViewPropertySetupTable mainTableClass">
                        <div className="stripped__table">
                            <div className="table-responsive tblDynamicPickupSticky">
                                <Table
                                    hover
                                    className="table-with-spacing positionStaticTable dailySummaryTbl"
                                >
                                    <thead className="tbl-header-sticky">

                                        <tr className="diff-bg-tr table-main-header-tr">
                                            <th className="border-right"></th>
                                            <th className="border-right text-end">ADR</th>
                                            <th className="border-right text-center">OTB</th>
                                            <th className="border-right text-end">REV</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border-right">Current</td>
                                            <td className="border-right text-end">{commonService.formateAmount(data?.[0]?.adr)}</td>
                                            <td className="border-right text-center">{data?.[0]?.otb}</td>
                                            <td className="border-right text-end">{commonService.formateAmount(data?.[0]?.total_revenue)}</td>
                                        </tr>
                                        <tr>
                                            <td className="border-right">STLY</td>
                                            <td className="border-right text-end">{commonService.formateAmount(data?.[0]?.stly_adr)}</td>
                                            <td className="border-right text-center">{data?.[0]?.stly_otb}</td>
                                            <td className="border-right text-end">{commonService.formateAmount(data?.[0]?.stly_revenue)}</td>
                                        </tr>
                                        <tr>
                                            <td className="border-right">LY</td>
                                            <td className="border-right text-end">{commonService.formateAmount(data?.[0]?.ly_adr)}</td>
                                            <td className="border-right text-center">{data?.[0]?.ly_rms}</td>
                                            <td className="border-right text-end">{commonService.formateAmount(data?.[0]?.ly_revenue)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ProposedRateModal;
